<div class="dropdown-wrapper">
<ejs-dropdowntree 
#locationDropDownTree
#locationTreeWrapper
id='locationField' 
[placeholder]="getEnabledSelectedCount() === 0 ? watermark : ''"
 [showCheckBox]='showCheckBox'
  [mode]='mode' 
 [treeSettings]='treeSettings'
  [fields]='treeFields'
  (change)="onLocationTreeChange($event)"
  cssClass="e-outline"
  [allowFiltering]="true"
  (dataBound)="onDataBound()"
  [filterType]="filterType" 
  (filtering)="onFiltering($event)"
  (select)="onNodeSelect($event)"
  (input)="onInput($event)"
  [customTemplate]="customTemplateRef"
  [showClearButton]="false"
  [enabled]="!disabled && !loading">
</ejs-dropdowntree>
 <!-- Custom Clear Button -->
<button
  *ngIf="getEnabledSelectedCount() > 0"
  mat-icon-button
  type="button"
  (click)="onCustomClear()"
  class="custom-clear-button"
>
  <mat-icon>clear</mat-icon>
</button>
<div *ngIf="loading" class="spinner-overlay">
  <mat-spinner [diameter]="20"></mat-spinner>
</div>
<ng-template #customTemplateRef let-data>
  <div class="custom-template-wrapper">
    <ng-container *ngIf="enabledSelectedCount > 0; else showPlaceholder">
      {{ enabledSelectedCount }} item{{ enabledSelectedCount > 1 ? 's' : '' }} selected
    </ng-container>
    <ng-template #showPlaceholder>
      <span class="location-placeholder">{{ watermark }}</span>
    </ng-template>
  </div>
</ng-template>
</div>

